export type NonNullableEntries<T> = {
  [P in keyof T]?: NonNullable<T[P]>;
};

export const removeNullAndUndefinedEntries = <T extends object>(
  values: T,
): NonNullableEntries<T> => {
  return Object.keys(values).reduce<NonNullableEntries<T>>((acc, key) => {
    const value = values[key as keyof typeof values];
    if (value == null) return acc;

    acc[key as keyof typeof acc] = value;
    return acc;
  }, {});
};
